const REQUIRED_ENV_VARS = [
  "VITE_API_URL_AFILIADOS",
  "VITE_API_URL_PRESTADORES",
  "VITE_API_URL_PROMOTORES",
  "VITE_API_URL_ROLES",
  "VITE_API_URL_USUARIOS",
  "VITE_API_URL_APIRENACER",
  "VITE_API_URL_APICARNETPRINT",
  "VITE_API_URL_AFILRENANWS",
  "VITE_API_URL_RESTABLECER_PASS",
  "VITE_PRIVATE_KEY",
  "VITE_SENTRY_DSN",
];

/**
 * Returns the names of any required env vars that are missing or empty.
 * Called once at startup in index.js before React renders.
 */
export function getMissingEnvVars() {
  return REQUIRED_ENV_VARS.filter((key) => !import.meta.env[key]);
}
